import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from './dashboard-routing.module';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { LinksGridComponent } from './shared/components/links-grid/links-grid.component';
import { ConnectLinksComponent } from './connect-links/connect-links.component';
import { ReportsDashboardComponent } from './reports/reports-dashboard/reports-dashboard.component';
import { GuidesAndVideosComponent } from './guides-and-videos/guides-and-videos.component';
import { ReportsEmbededComponent } from './reports/reports-embeded/reports-embeded.component';
import { ReportsItemComponent } from './reports/reports-item/reports-item.component';
import { ProjectsModule } from "../projects/projects.module";
import { CommitteesModule } from '../committees/committees.module';
import { NewsComponent } from './news/news.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ControlsModule } from '../controls/controls.module';
import { LayoutsModule } from '../layouts/layouts.module';

@NgModule({
  declarations: [
    DashboardComponent,
    ConnectLinksComponent,
    ReportsDashboardComponent,
    GuidesAndVideosComponent,
    ReportsEmbededComponent,
    ReportsItemComponent,
    LinksGridComponent,
    NewsComponent,

  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    MatSlideToggleModule,
    ProjectsModule,
    CommitteesModule,
    MatProgressSpinner,
    ControlsModule,
    LayoutsModule
]
})
export class DashboardModule { }
